export const SM = 320;
export const MD = 672;
export const LG = 1056;
export const XL = 1312;
export const MAX = 1584;
